import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IStagingDataInput } from '../../../interface/interfaces';

interface IInitialState {
    mergingLoading: boolean;
    merginData: string;
    merginError: string;
}

const initialState: IInitialState = {
    mergingLoading: false,
    merginData: '',
    merginError: '',
};

const mergingSlice = createSlice({
    name: 'merging',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchMergingDataPending: (state: IInitialState, action: PayloadAction<IStagingDataInput>) => {
            state.mergingLoading = true;
            state.merginData = '';
        },

        fetchMergingDataFulfilled: (state: IInitialState, action: PayloadAction<string>) => {
            state.mergingLoading = false;
            state.merginData = action.payload;
            state.merginError = '';
        },
        fetchMergingDataFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.mergingLoading = false;
            state.merginData = '';
            state.merginError = action.payload;
        },
    },
});

export default mergingSlice.reducer;
export const { fetchMergingDataPending, fetchMergingDataFulfilled, fetchMergingDataFailure } = mergingSlice.actions;
